import { composeEffects } from '../module';
import { transport } from '../transport';
import { ISession } from '../types';

import { getSession } from './selectors';

import { sessionActionCreators } from './actionsAndReducer';

export type FetchSessionOptions = {
  credential?: string;
  baseUrl?: string;
};

export const sessionEffects = composeEffects('session', (compose) => ({
  logoutSession: compose.payloadlessEffect(async () => {
    return transport
      .url('/api/v1/session')
      .delete()
      .res((r) => r)
      .then(() => {
        (window as any).location = '/auth/users/sign_in';
      });
  }),

  fetchSession: compose.effect(async (e: FetchSessionOptions) => {
    sessionActionCreators.fetchSession();

    return transport
      .url(`${e.baseUrl || ''}/api/v1/session`)
      .headers(e.credential ? { Cookie: e.credential } : {})
      .get()
      .json()
      .then((session: ISession): ISession => {
        sessionActionCreators.fetchSessionSuccess(session);
        return session;
      })
      .catch((error): ISession => {
        if (error.status === 404) {
          // 404 means you're not logged in, redirect to auth
          window.location.href = `/auth/users/sign_in?return_to=${encodeURIComponent(window.location.toString())}`;
        }
        throw error;
      });
  }),

  optionallyFetchSession: compose.statefulEffect(
    getSession,
    async (currentSession, e: { credential?: string; baseUrl?: string }) => {
      if (currentSession.id) {
        return Promise.resolve(currentSession);
      }

      sessionActionCreators.fetchSession();

      return transport
        .url(`${e.baseUrl || ''}/api/v1/session`)
        .headers(e.credential ? { Cookie: e.credential } : {})
        .get()
        .json()
        .then((session: ISession): ISession => {
          sessionActionCreators.fetchSessionSuccess(session);
          return session;
        })
        .catch((error): ISession => {
          if (error.status === 404) {
            // 404 means you're not logged in, redirect to auth
            (window as any).location = `/auth/users/sign_in?return_to=${encodeURIComponent(
              window.location.toString()
            )}`;
          }

          throw error;
        });
    }
  )
}));
